import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editItemUnit: {
    data: {},
    isEditMode: false,
  },
  showUnitInfos: {
    data: {},
    isShowUnitInfos: false,
  },
  showStockBatch: {
    data: {},
    isShowStockBatch: false,
  },
};

const productItemUnitSlice = createSlice({
  name: "productItemUnit",
  initialState,
  reducers: {
    setIsEditMode: (state, action) => {
      state.editItemUnit = action.payload;
    },
    setShowUnitInfos: (state, action) => {
      state.showUnitInfos = action.payload;
    },
    setShowStockBatch: (state, action) => {
      state.showStockBatch = action.payload;
    },
    clearEditUnitRelation: (state) => {
      state.editItemUnit = {
        data: {},
        isEditMode: false,
      };
    },
    clearUnitInfos: (state) => {
      state.showUnitInfos = {
        data: {},
        isShowUnitInfos: false,
      };
    },
    clearShowStockBatch: (state) => {
      state.showStockBatch = {
        data: {},
        isShowStockBatch: false,
      };
    },
  },
});

export const {
  setIsEditMode,
  setShowUnitInfos,
  setShowStockBatch,
  clearEditUnitRelation,
  clearUnitInfos,
  clearShowStockBatch,
} = productItemUnitSlice.actions;
export default productItemUnitSlice.reducer;
